import axios from 'axios'
import router from '../router/router'
import * as general_state from '../store/store';
import * as general_mutations from '../store/mutations';
import * as sections_list from '../store/modules/sections_list';
import * as evalvation from '../store/modules/evalvation';
import * as analytics from '../store/modules/analytics';
import * as evalvation_questionnaire from '../store/modules/evalvation_questionnaire';
import * as sections_detail from '../store/modules/sections_detail';
import * as sections_attachments from '../store/modules/sections_attachments';
import * as users from '../store/modules/users';


export const showModal = ({commit}, payload) => {
	commit('showModal', payload);
};

export const hideModal = ({commit}, payload) => {
	commit('hideModal', payload);
};

export const showModalWorking = ({commit}) => {
	commit('showModalWorking');
};

export const hideModalWorking = ({commit}) => {
	commit('hideModalWorking');
};


// Login user
export const loginUser = ({commit, dispatch}, payload) => {
    axios.post('?module=user&action=login_user&email='+payload.email, payload)
        .then(
            res => {
                // Login succesful
                if(res.data.success === true){

                    // Commit changes to store (user, faculty, token...)
                    dispatch('getActiveYear');
                    commit('setAuthData', res);
                    commit('setToken', res.data.token);

                    // Save token, faculty_id and user id to local storage
                    localStorage.setItem('token', res.data.token);
                    //localStorage.setItem('user_id', res.data.user.id);
                    localStorage.setItem('faculty', JSON.stringify(res.data.faculty));
                    localStorage.setItem('year', general_state.state.active_year_date.active_year);
                    let expirationDate = new Date(new Date().getTime() + general_state.state.expirationTime).getTime();
                    localStorage.setItem('expirationDate', expirationDate);

                    //Redirect based on access
                    if(general_state.state.user.access_sections == 1){
                        router.replace('/podrocja/');
                    }
                    else if(general_state.state.user.access_work_plan == 1){
                        router.replace('/program-dela/');
                    }
                    else if(general_state.state.user.access_evalvation == 1){
                        router.replace('/samoevalvacija/programi/');
                    }
                    
                    // Start activity tracking after successful login
                    dispatch('startActivityTracking');
                }
                // Login failed
                else{
                    alert(res.data.error);
                }
            }
        )
        .catch(error => {
            if (error.code === 'ECONNABORTED' || error.name === 'CanceledError') {
                console.log('Request canceled:', error.config?.url);
                return;
            }
            console.log('Request failed:', error);
        })		
};

// Logout user without full page reload (used by token expiry interceptor)
export const logoutWithoutReload = async ({ commit, dispatch }) => {
    commit('clearAuthData');
    await dispatch('clearMsalSession');
    router.replace('/login/');
};

// Logout user
export const logoutUser = async ({ commit, dispatch }) => {
    commit('clearAuthData');
    await dispatch('clearMsalSession');
    location.reload();
};

export const clearMsalSession = async () => {
    const { logoutMsal } = await import('@/auth/msal');
    await logoutMsal();
};


// Get db version from db - not shown in UI, only in hidden footer element for quick check in inspector
export const prepareDbVersion = ({commit}, payload) => {
    axios.get('?module=other&action=get_version')
			.then(
				res => {
					if(!res.status == 200){				
						commit('showModal', {component: 'ModalError', data: res})
					}
					else{
						commit('prepareDbVersion', res.data);
					}
				}
			)
			.catch(error => {
                if (error.code === 'ECONNABORTED' || error.name === 'CanceledError') {
                    console.log('Request canceled:', error.config?.url);
                    return;
                }
                console.log('Request failed:', error);
            })	
};


// Set active faculty and section for admin
export const changeFacultySection = ({commit}, payload) => {

    if(payload.data.faculty_id)
        commit('changeFaculty', payload.data.faculty_id);

    // Get data for new faculty (statistics)
    sections_list.default.actions.prepareSectionsStat({commit});

    if(router.currentRoute.value?.matched?.[0]?.path == '/program-dela/' || router.currentRoute.value?.matched?.[0]?.path == '/program-dela'){
        router.replace('/program-dela/podrobnosti/'+payload.data.section_id).catch(err=>{});
    }
    else
        router.replace('/podrocja/podrobnosti/'+payload.data.section_id).catch(err=>{});
    
};

// Get all faculties from database
export const prepareFaculties = ({commit}, payload) => {
    axios.get('?module=faculty&action=get_faculties')
			.then(
				res => {
					if(!res.status == 200){				
						commit('showModal', {component: 'ModalError', data: res})
					}
					else{
						commit('prepareFaculties', res.data);
					}
				}
			)
			.catch(error => {
                if (error.code === 'ECONNABORTED' || error.name === 'CanceledError') {
                    console.log('Request canceled:', error.config?.url);
                    return;
                }
                console.log('Request failed:', error);
            })	
};

// Set active faculty for admin
export const changeFaculty = ({commit, dispatch, getters}, faculty_id) => {

    commit('changeFaculty', faculty_id);

    // Get data for new faculty (statistics)
    sections_list.default.actions.prepareSectionsStat({commit});

    // Get data for attachments for this faculty
    sections_attachments.default.actions.getFacultyAttachments({commit});

    // Get data for departments of this faculty
    evalvation.default.actions.getDepartmentsListForFaculty({commit});

    // If we are in evalvation, redirect to evalvation
    if(router.currentRoute.value?.matched?.[0]?.path == '/samoevalvacija/' || router.currentRoute.value?.matched?.[0]?.path == '/samoevalvacija'){

        //To refresh internal questionnaire if faculty has it
        if(getters.faculties_internal_permission.includes(faculty_id) && 
            (router.currentRoute.value.name == 'questionnaireBuild' || router.currentRoute.value.name == 'questionnaireBuildDoc')){
            evalvation_questionnaire.default.actions.getQuestionnaireDetails({commit, dispatch}, 
                    {type: router.currentRoute.value.name == 'questionnaireBuildDoc' ? 4 : 1});
        }
        
        if(router.currentRoute.value.name == 'evalvationPrograms'){
            evalvation.default.actions.getProgramsListForFaculty({commit});
        }
        else if(router.currentRoute.value.name == 'departmentsQuestionnaire'){
            evalvation_questionnaire.default.actions.getQuestionnaireDetails({commit}, {type: '2_'+faculty_id});
        }
        //router.replace('/samoevalvacija/').catch(err=>{});
    }

    else if(router.currentRoute.value?.matched?.[0]?.path == '/program-dela/' || router.currentRoute.value?.matched?.[0]?.path == '/program-dela'){
        router.replace('/program-dela/').catch(err=>{});
    }
        
    // Redirect to sections list
    else
        router.replace('/podrocja/').catch(err=>{});
};

// Change school year - set year (const year) and then get all sections from db
export const changeYear = ({commit, dispatch}, year) => {
    commit('changeYear', year);

    dispatch('isActiveYear', {commit, dispatch});

    if(general_state.state.user.access_evalvation == 1){
        evalvation.default.actions.resetProgramsMultipleFill({commit});

        if(general_state.state.user.type > 0){
            evalvation.default.actions.getDepartmentsListForFaculty({commit});
            evalvation.default.actions.getProgramsListForFaculty({commit});
        }
        else{
            evalvation.default.actions.getDepartmentsListForUser({commit});
            evalvation.default.actions.getProgramsListForUser({commit});
        }

        if(general_state.state.user.type > 1){
            evalvation.default.actions.getProgramsListAll({commit});
            analytics.default.actions.getEvalvationStatisticsByFaculty({commit});            
        }
    }
    
    if(router.currentRoute.value.name == 'questionnaireBuild'){
        evalvation_questionnaire.default.actions.getQuestionnaireDetails({commit, dispatch}, {type: 1, year: year});
    }
    else if(router.currentRoute.value.name == 'questionnaireBuildDoc'){
        evalvation_questionnaire.default.actions.getQuestionnaireDetails({commit, dispatch}, {type: 4, year: year});
    }
    else if(router.currentRoute.value.name == 'sectionsDashboard'){
        sections_list.default.actions.getDashboard({commit});
    }
    else if(general_state.state.user.access_sections == 1 || general_state.state.user.access_work_plan == 1){
        // Get data for this year and faculty
        sections_list.default.actions.prepareSections({commit});
        sections_list.default.actions.getSectionsIntro({commit});
        sections_list.default.actions.prepareSectionsStat({commit});
        sections_attachments.default.actions.getFacultyAttachments({commit});
        sections_list.default.actions.getSectionsImages({commit});

        // Redirect to sections list
        if(router.currentRoute.value?.matched?.[0]?.path == '/podrocja/' || router.currentRoute.value?.matched?.[0]?.path == '/podrocja')
            router.replace('/podrocja/').catch(err=>{});
        if(router.currentRoute.value?.matched?.[0]?.path == '/program-dela/' || router.currentRoute.value?.matched?.[0]?.path == '/program-dela')
            router.replace('/program-dela/').catch(err=>{});
    }

    //just in case
    else if(router.currentRoute.value?.matched?.[0]?.path == '/samoevalvacija/' || router.currentRoute.value?.matched?.[0]?.path == '/samoevalvacija')
        router.replace('/samoevalvacija/').catch(err=>{});
};

// Is chosen yer an active year - if not, show warning(s)
export const isActiveYear = ({commit, dispatch}) => {
    if(general_state.state.year == general_state.state.active_year_date.active_year){
            return true;
    }
    else{
        commit('showModal', {component: 'ModalWarning', data: {title: 'Opozorilo', 
            description: 'Izbrali ste študijsko leto, ki trenutno ni aktivno. Pri urejanju podatkov bodite še posebej previdni!'}});
        return false;
    }
};

// Is chosen year an active year - if not, show warning(s)
export const getActiveYear = ({commit, dispatch}) => {
    let active_year_date = general_state.state.active_year_date;

    /* let current_date = new Date();
    let year = current_date.getFullYear();

    if(current_date.getMonth() > active_year_date.month ||
        (current_date.getMonth() == active_year_date.month && current_date.getDate() >= active_year_date.day)){
            let newyear = (year-1)+'/'+year;
            commit('changeYear', newyear);
            commit('changeYearDateYear', newyear);
    }
    else{
        let newyear = (year-2)+'/'+(year-1);
        commit('changeYear', newyear);
        commit('changeYearDateYear', newyear);
    } */
    commit('changeYear', active_year_date.active_year);
};

// Set active faculty for admin
export const downloadFile = (_, {url, filename=''}) => {
    //some browsers blocks download if we open link in another tab
    //window.open(res.data.export_link); 

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};